module.exports = __webpack_public_path__ + "static/FireStoreData-ffcc39df10b01351ca0f2070755588ad.png";